// Chakra imports
import {
	Box,
	Flex,
	Grid,
	Icon,
	Text,
	SimpleGrid,
	HStack,
	Stack,
	Button,
} from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import { BsCheckCircle } from "react-icons/bs";

function Billing() {
	return (
		<SimpleGrid
			pt={{ base: "120px", md: "75px" }}
			columns={{ sm: 1, md: 2, lg: 2 }}
			spacing={10}
		>
			<Flex direction="column" gap={5}>
				<HStack justify="space-between">
					<Text fontSize="4xl">History</Text>
					<Stack direction="row">
						<Button>Edit Billing Info</Button>
						<Button leftIcon={<DownloadIcon />} variant="solid"></Button>
					</Stack>
				</HStack>
				{[1, 2, 3, 4, 5, 6].map((i) => (
					<HStack justify="space-between" key={i}>
						<Flex direction="column">
							<Text fontSize="15px">Basic Plan</Text>
							<Text color="#969696">19 April,12:00</Text>
						</Flex>
						<Flex direction="column" align="end">
							<Text fontSize="15px">$ 19,999.00</Text>
							<Text color="#969696">Card 0123</Text>
						</Flex>
					</HStack>
				))}
			</Flex>
			<Flex direction="column" gap={10}>
				<Text fontSize="4xl">Our Plans</Text>
				<HStack
					justify="space-between"
					bg="#33333B"
					p="24px"
					borderRadius="12px"
				>
					<Stack direction="column" spacing={3}>
						<Text fontSize="24px" fontWeight="bold">
							Free Tier
						</Text>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Lorem Ipsum
						</Text>
					</Stack>
					<Stack direction="column" spacing={3}>
						<Button>Your Currrent Plan</Button>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Vivamus sed urna ac
						</Text>
					</Stack>
				</HStack>
				<HStack
					justify="space-between"
					bg="#33333B"
					p="24px"
					borderRadius="12px"
				>
					<Stack direction="column" spacing={5}>
						<Text fontSize="24px" fontWeight="bold">
							Unlocked
						</Text>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Lorem Ipsum
						</Text>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Lorem Ipsum
						</Text>
					</Stack>
					<Stack direction="column" spacing={3}>
						<Button bg="#16BF5D" borderRadius="16px" py="12px" px="24px">
							Learn More
						</Button>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Lorem Ipsum
						</Text>
						<Text>
							<Icon as={BsCheckCircle} color="#71C9EC" /> Lorem Ipsum
						</Text>
					</Stack>
				</HStack>
			</Flex>
		</SimpleGrid>
	);
}

export default Billing;
